<template>
  <customreport :report="0" />
</template>
<script>
import customreport from '@telexpress_auth/vue-customreport/dist/components/customreport.umd.min';

export default {
  components: {
    customreport,
  },
};
</script>
